import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Session validation still in progress — never redirect yet.
  if (loading)
    return (
      <div className="h-screen flex items-center justify-center bg-[#F8FAFC]" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#00C9E0]" />
      </div>
    );

  // Genuinely unauthenticated — go to login, remembering where we wanted to go.
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return children;
}
